import React from "react";
import { Box, ScrollArea, Table, Text, createStyles } from "@mantine/core";
import { useState } from "react";
import { useSelector } from "react-redux";
import PlanTableRow from "../PlanTableRow";
import RecordNotFound from "../RecordNotFound";
import TableLoader from "../TableLoader";
import { useDisclosure } from "@mantine/hooks";
import ViewCarePlanModal from "../SupportModal/ViewCarePlanModal";
import SupportModal from "../SupportModal";
import CarePlanUpdate from "../MAR/CarePlanUpdate";
import ForceMoveCarePlan from "../MAR/ForceMoveCarePlan";

const useStyles = createStyles((theme) => ({
  header: {
    position: "sticky",
    top: 0,
    zIndex: 1,
    transition: "box-shadow 150ms ease",
    "& th": {
      color: "var(--app-text) !important",
      fontFamily: "Inter !important",
      fontSize: "14px !important",
      fontWeight: "700 !important",
      padding: "14px 12px !important",
    },
    "&::after": {
      content: '""',
      position: "absolute",
      left: 0,
      right: 0,
      bottom: 0,
    },
  },

  body: {
    "& tr td": {
      backgroundColor: "var(--app-surface)",
    },
    "& tr:nth-of-type(odd) td": {
      backgroundColor: "var(--app-surface-2)",
      color: "var(--app-text)",
      fontFamily: "Inter",
      fontSize: "14px !important",
      fontWeight: "400",
      padding: "14px 12px",
    },
  },

  scrolled: {
    boxShadow: theme.shadows.sm,
  },
  notFound: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "space-evenly",
    height: "75vh",
    gap: "8rem",
  },
  notFoundText: {
    color: "var(--app-text-muted)",
    fontFamily: "Inter",
    fontSize: "22px",
    fontStyle: "normal",
    fontWeight: "400",
    lineHeight: "normal",
  },
  tableParent: {
    padding: "12px 8px",
    borderRadius: "16px",
    marginTop: "14px",
    background: "var(--app-surface)",
  },
  scrollArea: {
    borderRadius: "8px",
    border: "1px solid var(--app-border)",
  },
}));

const PlanTable = ({
  setRowData,
  setShowCarePlanDetails,
  segment,
  client,
  currentPage,
  setIsView,
  search,
  rowData,
}) => {
  console.log("🚀 ~ PlanTable ~ client:", client)
  const { classes, cx } = useStyles();
  const [opened, { open, close }] = useDisclosure(false);
  const [_opened, { open: _open, close: _close }] = useDisclosure(false);
  const { plans, loading } = useSelector((state) => state.supportPlan);
  const [scrolled, setScrolled] = useState(false);
  const [row, setRow] = useState(null);
  const [view, setView] = useState(false);

  console.log("care plans :", plans)

  let filtered_plans = []

  if(search){
    filtered_plans = plans?.filter((_p) => _p?.client?.name?.toLowerCase()?.includes(search?.toLowerCase()) || _p?.facility?.name?.toLowerCase()?.includes(search?.toLowerCase()))
  } else {
    filtered_plans = plans
  }

  const rows = filtered_plans?.map((row, i) => (
    <PlanTableRow
      segment={segment}
      client={client}
      currentPage={currentPage}
      row={row}
      open={(data) => {
        setRow(data);
        setRowData(data);
        setShowCarePlanDetails(true);
        // open();
      }}
      openView={(data) => {
        setRow(data);
        setRowData(data);
        setIsView(true);
        setShowCarePlanDetails(true);
        // open()
      }}
      openForce={(data) => {
        setRow(data);
        setRowData(data);
        _open();
      }}
      key={i}
      setView={setView}
    />
  ));
  return (
    <>
      <Box className={classes.tableParent}>
        <ScrollArea
          onScrollPositionChange={({ y }) => setScrolled(y !== 0)}
          className={classes.scrollArea}
        >
          {/* <SupportModal
          opened={opened}
          close={close}
          title={"Edit Support Plan"}
          data={row}
          view={view}
        /> */}
          <ViewCarePlanModal
            data={row}
            view={open}
            onclose={close}
            opened={opened}
            setRowData={setRowData}
            setShowCarePlanDetails={setShowCarePlanDetails}
          />
          <ForceMoveCarePlan
            client={client}
            data={row}
            view={_open}
            onclose={_close}
            opened={_opened}
            rowData={rowData}
          />
          <Table
            fontSize={"sm"}
            highlightOnHover
            enableStickyHeader
            verticalSpacing={"md"}
            sx={{
              fontFamily: "Inter",
              borderRadius: "16px",
            }}
          >
            <thead
              // style={
              //   segment === "Active"
              //     ? { background: "#000", color: "#fff !important" }
              //     : { background: "var(--app-surface-2)", color: "var(--app-text) !important" }
              // }
              className={cx(classes.header, { [classes.scrolled]: scrolled })}
            >
              {segment === "Active" ||
              segment === "active" ||
              segment === "draft" ? (
                <tr>
                  <th style={{ minWidth: "200px" }}>Plan Type</th>
                  <th style={{ minWidth: "200px" }}>Client Name</th>
                  <th style={{ minWidth: "140px" }}>Facility Name</th>
                  <th style={{ minWidth: "140px" }}>Outcomes</th>
                  <th style={{ minWidth: "140px" }}>Action</th>
                </tr>
              ) : (
                <tr>
                  <th style={{ minWidth: "200px" }}>Plan Type</th>
                  <th style={{ minWidth: "200px" }}>Plan Start Date</th>
                  <th style={{ minWidth: "140px" }}>Discontinue Date</th>
                  <th style={{ minWidth: "140px" }}>Discontinue Reason</th>
                  <th style={{ minWidth: "140px" }}>Action</th>
                </tr>
              )}
            </thead>

            <tbody className={classes.body}>
              {loading ? (
                <tr>
                  <td colSpan={1000}>
                    <TableLoader />
                  </td>
                </tr>
              ) : rows?.length ? (
                <>{rows}</>
              ) : (
                <tr>
                  <td colSpan={1000}>
                    <Box className={classes.notFound}>
                      <RecordNotFound />
                      <Text className={classes.notFoundText}>
                        You don&apos;t have any record, click on “Add Care Plan”
                      </Text>
                    </Box>
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </ScrollArea>
      </Box>
    </>
  );
};

export default PlanTable;
